// The seed a trace tab opens on when the row itself isn't in hand — a deep link
// or a reload, where the id is all the URL carries. getTrace replaces it with
// the real payload; until then it is what the panel renders.
//
// It deliberately carries NO event time. A deep link cannot know when the trace
// ran, and stamping the clock here (as this used to) put the current time under
// the panel header as though it had been observed. `placeholder` is how the
// loading skeleton tells this seed from a trace-log row, which arrives with its
// real summary and timestamp already correct.
export function makeLoadingTrace(traceId) {
  return {
    id: traceId,
    traceId,
    placeholder: true,
    timestamp: null,
    summary: "Loading trace",
    operation: "ai.prompt",
    model: "",
    provider: "",
    providerApi: "",
    inputTokens: 0,
    outputTokens: 0,
    totalTokens: 0,
    endpointId: "",
    endpointName: "",
    sessionId: "",
    sessionTitle: "",
    sessionStatus: "",
    clusterIds: [],
    primaryClusterId: null,
    primaryClusterName: "",
    clusterStatus: "pending",
    clusterAncestors: [],
    sessionClusters: [],
    turns: [],
    tools: [],
    settings: null,
    apiRequestRaw: "",
    prevTraceInSession: null,
  };
}

export function makeTraceTab(traceId, data, originScopePath = [], state = {}) {
  return {
    type: "trace",
    id: traceId,
    data,
    ...state,
    originScopePath: [...originScopePath],
  };
}
